import CryptoJS from "crypto-js"

let Information = {};
const sdk_ver = '1.0.11';
const app_ver = '0.0.1';
window.addEventListener('error', function(e) {
    console.log(e)
    console.log(e.target)
})
/**
 * 埋点上报
 * 2023-02-02
 *
 */
if (!sessionStorage.getItem('sdk_app_id') && !sessionStorage.getItem('sdk_app_key')){
    Y()
}
/**
 * 判断否是IOS还是安卓
 * @type {null}
 */
function Y(){
    let isAndroid = null;
    let isIOS = null;
    var u = navigator.userAgent;
    isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) {
        console.log('安卓')
    } else if (isIOS) {
        if (window.webkit && window.webkit.messageHandlers.getIDFA !== undefined) {
            window.webkit.messageHandlers.getIDFA.postMessage('Javascript invoke OC');
            window.IOSInformation = IOSInformation
        }
    }
    function IOSInformation(res){
        Information = JSON.parse(res)
    }
}
/**
 * 埋点
 * @type {burying} 方法名收
 */
export default {
    Burying(key) {
        let burying = JSON.stringify({
            appid: sessionStorage.getItem("sdk_app_id") || sessionStorage.getItem("appid"),
            sdk_ver: sdk_ver,
            app_ver: app_ver,
            channel:  sessionStorage.getItem('sdk_channel_id') || sessionStorage.getItem("gameid"),
            boxid:'',
            device: {
                type: Information.type || "H5",
                model: Information.model || isMobile(),
                id: Information.id || uuid(),
                id1: '',
                id2: '',
                id3: '',
                os: Information.os || browserRedirect(),
                width: window.innerWidth,
                height: window.innerHeight,
                lang: Information.lang || navigator.language,
                idfv: Information.idfv || ''
            },
            net_type: Information.net_type || getNetworkType(),
            user: {
                id: key.uid
            },
            event: {
                time: Date.now()/ 1000 | 0,
                name: key.eventname,
                type: key.eventtype
            },
            properities: key.properities,
        });
        let headers = objKeySort(burying)
        // ajax('post', '//log-pre.tj.996Sdk.com/v1/event', burying, headers);  // pre
        // ajax('post', '//track-test.tj.996sdk.com/v1/event', burying, headers);
        ajax('post', '//log.tj.996sdk.com/v1/event', burying, headers); //正式
        return burying
    },
    //let data = {"net_type":"WIFI","app_ver":"SDKDemo1.0.0","appid":"ZykOLEtM3jav","channel":"123","sdk_ver":"1.2.2","device":{"type":"android","model":"HONOR:FNE-AN00","id1":"","id2":"f2eced5e3d7a124b","id3":"ca127fac-bba1-4657-94fa-3ac2c6bdfb1b","os":"12","width":"1080","height":"2316","lang":"zh","id":"ca127fac-bba1-4657-94fa-3ac2c6bdfb1b","net_type":"WIFI"}}
    Escalation() {
        let data = {
            net_type: '' || getNetworkType(),
            app_ver: app_ver,
            appid: sessionStorage.getItem('sdk_app_id') || sessionStorage.getItem("appid"),
            channel: sessionStorage.getItem('sdk_channel_id') || sessionStorage.getItem("gameid"),
            sdk_ver: sdk_ver,
            device:{
                type: Information.type  || 'H5',
                model: Information.model || isMobile(),
                id: Information.id || uuid(),
                id1: '',
                id2: "",
                id3: '',
                os: Information.os  || browserRedirect(),
                width: window.innerWidth,
                height: window.innerHeight,
                lang: Information.lang || navigator.language,
                net_type: Information.net_type || getNetworkType(),
                idfv: Information.idfv || ''
            }
        }
        // return JSON.stringify(encodeURIComponent(data))
        return encodeURIComponent(JSON.stringify(data))
    }
}
/**
 * 判断是否是浏览器
 */
function isMobile () {
    var u = navigator.userAgent;
    if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {//安卓手机
        console.log("安卓手机");
        return 'Android'
    } else if (u.indexOf('iPhone') > -1) {//苹果手机
        console.log("苹果手机");
        return 'iOS'
    } else if (u.indexOf('Windows Phone') > -1) {//winphone手机
        console.log("winphone手机");
        return 'Winphone'
    } else {
        return 'PC'
    }
}
/**
 * UUID
 * 如果是浏览器或者是电脑用户就用本方法
 */
function uuid() {
    let uuid996 = localStorage.getItem('uuid996' + sessionStorage.getItem('sdk_app_key'))
    let i = ''
    if (uuid996 == null) {
        i = guid()
        localStorage.setItem('uuid996' + sessionStorage.getItem('sdk_app_key'), i)
    } else {
        i = uuid996
    }
    return i
}
function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
/**
 * 取当前操作系统
 */
function browserRedirect(){
    var sUserAgent = navigator.userAgent;
    var isWin = (navigator.platform === "Win32") || (navigator.platform == "Windows");
    var isMac = (navigator.platform === "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
    if (isMac) return "Mac";
    var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
    if (isUnix) return "Unix";
    var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
    if (isLinux) return "Linux";
    if (isWin) {
        var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
        if (isWin2K) return "Win2000";
        var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
        if (isWinXP) return "WinXP";
        var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
        if (isWin2003) return "Win2003";
        var isWinVista= sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
        if (isWinVista) return "WinVista";
        var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
        if (isWin7) return "Win7";
        var isWin10 = sUserAgent.indexOf("Windows NT 10") > -1 || sUserAgent.indexOf("Windows 10") > -1;
        if (isWin10) return "Win10";
        var isWin11 = sUserAgent.indexOf("Windows NT 11") > -1 || sUserAgent.indexOf("Windows 11") > -1;
        if (isWin11) return "Win11";
    }
    return "other";
}
/**
 * 取网络类型
 */
function getNetworkType (){
    var ua = navigator.userAgent;
    var networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other';
    networkStr = networkStr.toLowerCase().replace('nettype/', '');
    var networkType;
    switch (networkStr) {
        case 'wifi': networkType = 'wifi'; break;
        case '5g': networkType = '5G'; break;
        case '4g': networkType = '4G'; break;
        case '3g': networkType = '3G'; break;
        case '3gnet': networkType = '3G'; break;
        case '2g': networkType = '2G'; break;
        default: networkType = 'UNKNOWN';
    }
    return networkType;
}
/**
 * 封装ajax
 * @param method:请求的方式get还是post
 * @param url:请求的地址
 * @param params:发送的参数
 * @callback 返回响应调用的函数
 * */
function ajax(method, url, params, header) {
    var xhr = new XMLHttpRequest();
    xhr.open(method, url);
    Object.keys(header).forEach(key => {
        xhr.setRequestHeader(key, header[key])
    })
    if (method.toLowerCase() === 'get') {//判断请求方式
        xhr.send(params);
    } else {
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(params);
    }
    xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
            // console.log(xhr.responseText);
        }
    }
}

/**
 * 随机16位
 * @returns {string}
 */
function getRamNumber() {
    var result = '';
    for (var i = 0; i < 16; i++) {
        result += Math.floor(Math.random() * 16).toString(16);//获取0-15并通过toString转16进制
    }

//默认字母小写，手动转大写
    return result.toUpperCase();//另toLowerCase()转小写
}
// 签名排序
function objKeySort(body) {
    //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    let headers = {
        'x-996sdk-appid': sessionStorage.getItem('sdk_app_id'),
        'x-996sdk-algo':  'MD5',
        'x-996sdk-nonce':  getRamNumber(),
        'x-996sdk-timestamp':  Date.now()/ 1000 | 0
    }
    let xargs = ['POST','/v1/event']
    Object.keys(headers).sort().forEach(key => {
        xargs.push(key + "=" + headers[key])
    });
    xargs.push(body);
    xargs.push("key=" + sessionStorage.getItem('sdk_app_key'));
    headers["x-996sdk-sign"] = CryptoJS.MD5(xargs.join("\n")).toString();
    return headers;
}
